import { baseApi, providesList } from '@/shared/api'
import type {
  CatalogFiltersQuery,
  CatalogFilterList,
  CatalogProductCard,
  CatalogProductCardQuery,
  CatalogProductList,
  CatalogProductsQuery,
  CatalogReferenceList,
  CatalogReferenceQuery,
} from '../model/types'

/*
 * Все ручки каталога принимают модификатор (`client`, `account`, `unp`, `settlement`, `cart`):
 * он едет в аргументах, поэтому кеш вида клиента и полного вида не смешивается.
 */
export const productApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /** Страница выдачи: отбор, поиск, сортировку и подсчёт делает бэк. */
    getProducts: build.query<CatalogProductList, CatalogProductsQuery>({
      query: (params) => ({ url: '/catalog/products', params }),
      providesTags: (res) => providesList(res?.items, 'Product'),
    }),

    /** Карточка товара: та же форма, что у строки выдачи. */
    getProduct: build.query<CatalogProductCard, { id: string } & CatalogProductCardQuery>({
      query: ({ id, ...params }) => ({
        url: `/catalog/products/${encodeURIComponent(id)}`,
        params,
      }),
      providesTags: (_res, _err, { id }) => [{ type: 'Product', id }],
    }),

    /** Пары «параметр — значение» узла дерева: весь набор, без страниц (так отдаёт бэк). */
    /** Пары «свойство — значение» узла страницей; `q` — подстрока свойства или значения. */
    getCatalogFilters: build.query<CatalogFilterList, CatalogFiltersQuery>({
      query: (params) => ({ url: '/catalog/filters', params }),
    }),

    /**
     * Справочник «Категория» или «Модель» страницей в порядке значений; выбранное значение
     * другого сужает список. Поиска у ручки нет.
     */
    getCatalogReference: build.query<CatalogReferenceList, CatalogReferenceQuery>({
      query: (params) => ({ url: '/catalog/reference', params }),
    }),
  }),
})

export const {
  useGetProductsQuery,
  useGetProductQuery,
  useGetCatalogFiltersQuery,
  useGetCatalogReferenceQuery,
} = productApi
